module.exports = __webpack_public_path__ + "img/yiyao_zhongmu_suoluetu.592fe4f8.png";